module.exports = __webpack_public_path__ + "static/JkNourry-cf081a0cef8f96c3174f4a97c8a020e5.png";